import React, { Component } from 'react'
import { AutoComplete, Button, Checkbox, Icon, Input, Row, Col } from 'antd'
import InputNumber from 'rc-input-number'
import numeral from 'numeral'
import _ from 'lodash'

import * as totalCalculator from '../../utils/totalCalculator'
import SmartInputNumber from '../SmartInputNumber/SmartInputNumber'
import UploadWithPopupPreview from '../UploadWithPopupPreview/UploadWithPopupPreview'
import 'antd/lib/input-number/style/css';
import './DocumentContentTable.scss'

const Option = AutoComplete.Option
const { getItemTotal, getSectionTotal, getGrandTotal } = totalCalculator

export default class DocumentContentTable extends Component {
    handleItemNameRemove(e, itemName) {
        const { token, removeItemName } = this.props
        e.stopPropagation()
        removeItemName(token, itemName)
    }

    renderItemRow(sectionIdx, sectionOriginalIdx, itemList) {
        const {
            status,
            type,
            isDocumentSent,
            itemNameSuggestionList,
            unitSuggestionList,
            itemSmartSuggestionList,
            onSuggestionItemClick,
            onItemInsert,
            onItemFocus,
            onItemRemove,
            onItemChange,
            onItemValueChange,
            onItemImageChange
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'
        const isNotice = type === 'notice'
        const isWP = type === 'working-progress'
        const isWPR = type === 'work-progress-report'
        const itemNameOptions = _.map(itemNameSuggestionList, (itemName, idx) => (
            <Option key={itemName}>
                {itemName}
                <div className="item-name-delete-btn" onClick={(e) => this.handleItemNameRemove(e, itemName)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))

        if (isWP || isWPR)
            return _.map(itemList, (item, itemIdx) => {
                const { name, imageUrl, progress } = item
                return (
                    <tr key={`${sectionIdx}-${itemIdx}`}>
                        <td className="item-idx-field">{sectionIdx + 1}.{itemIdx + 1}</td>
                        <td className="item-name-field">
                            <div className="table-item">{name}</div>
                        </td>
                        <td>
                            <UploadWithPopupPreview
                                itemImageUrl={imageUrl}
                                itemImageChange={(url) => onItemImageChange(sectionIdx, itemIdx, url)}
                                isLocked={isWPR}
                            />
                        </td>
                        <td>
                            {isWPR ? progress : <Input value={progress} onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'progress')}/>}
                        </td>
                    </tr>
                )
            })
        else
            return _.map(itemList, (item, itemIdx) => {
                const { original_idx: itemOriginalIdx, name, quantity, basic_charge_quantity, basic_charge, unit_rate, unit, imageUrl, optional } = item
                let returnComponent = []
                returnComponent.push(
                    <tr key={`${sectionOriginalIdx || sectionIdx}-${itemOriginalIdx || itemIdx}`}>
                        <td className="insert-item-field">
                            {
                                !isLocked && !isNotice && (
                                    <div className="insert-item-btn" onClick={onItemInsert.bind(this, sectionIdx, itemIdx)}>
                                        <Icon type="rollback" />
                                    </div>
                                )
                            }
                        </td>
                        <td className="item-idx-field">{(sectionOriginalIdx || sectionIdx) + 1}.{(itemOriginalIdx || itemIdx) + 1}</td>
                        <td className="item-name-field">
                            { 
                                isLocked || isNotice ? <div className="table-item">{name}</div> :
                                <AutoComplete
                                    value={name}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'name')}
                                    dataSource={itemNameOptions}
                                    optionLabelProp='value'
                                    style={{width: '100%'}}
                                    filterOption={(inputValue, option) => option.props.children[0].toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                    dropdownMatchSelectWidth={false}
                                />
                            }
                        </td>
                        <td width={60}>
                            { 
                                isLocked  ? <div className="table-item">{quantity}</div> :
                                <InputNumber
                                    prefixCls="ant-input-number" 
                                    value={quantity}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'quantity')}
                                />
                            }
                        </td> 
                        <td width={80}>
                            { 
                                isLocked || isNotice ? <div className="table-item">{basic_charge_quantity && `First ${basic_charge_quantity}`}</div> :
                                <SmartInputNumber 
                                    isSmartSuggestionDisabled={isNotice}
                                    prefixCls="ant-input-number" 
                                    min={1} 
                                    formatter={value => value ? `First ${value}` : ''}
                                    parser={value => value.replace(/[^0-9.]/g, '')}
                                    value={basic_charge_quantity}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'basic_charge_quantity')}
                                    onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                                    onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={80}>
                            { 
                                isLocked || isNotice ? <div className="table-item">{basic_charge && `$ ${numeral(basic_charge).format('0,0')}`}</div> :
                                <SmartInputNumber 
                                    isSmartSuggestionDisabled={isNotice}
                                    prefixCls="ant-input-number" 
                                    formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    value={basic_charge}
                                    min={0}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'basic_charge')}
                                    onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                                    onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={70}>
                            { 
                                isLocked || isNotice ? <div className="table-item">{unit_rate && `$ ${numeral(unit_rate).format('0,0')}`}</div> :
                                <SmartInputNumber 
                                    isSmartSuggestionDisabled={isNotice}
                                    prefixCls="ant-input-number" 
                                    formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    value={unit_rate}
                                    min={0}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'unit_rate')}
                                    onFocusFetcher={onItemFocus.bind(this, sectionIdx, itemIdx)}
                                    onRowClick={(selectedItem) => onSuggestionItemClick(sectionIdx, itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={50}>
                            { 
                                isLocked || isNotice ? <div className="table-item">{unit}</div> :
                                <AutoComplete
                                    value={unit}
                                    onChange={onItemValueChange.bind(this, sectionIdx, itemIdx, 'unit')}
                                    dataSource={unitSuggestionList}
                                    style={{width: '100%'}}
                                    filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                    dropdownMatchSelectWidth={false}
                                />
                            }
                        </td>
                        <td><div className="table-item">{numeral(getItemTotal(item)).format('$ 0,0.[0]')}</div></td>
                        <td>
                            <UploadWithPopupPreview
                                isLocked={isLocked || isNotice}
                                itemImageUrl={imageUrl}
                                itemImageChange={(url) => onItemImageChange(sectionIdx, itemIdx, url)}
                            />
                        </td>
                        <td>
                            <Checkbox 
                                checked={optional} 
                                disabled={isLocked || isNotice}
                                onChange={onItemChange.bind(this, sectionIdx, itemIdx, 'optional')}
                            />
                        </td>
                        <td>
                            {
                                !isLocked && (
                                    <div className="rm-item-btn" onClick={onItemRemove.bind(this, sectionIdx, itemIdx)}>
                                        <Icon type="close" />
                                    </div>
                                )
                            }
                        </td>
                    </tr>
                )

                return returnComponent
            })
    }

    renderRemarkRow(sectionIdx, sectionOriginalIdx, remarkList) {
        const {
            // status,
            type,
            // isDocumentSent,
            onSectionRemarkInsert,
            onSectionRemarkRemove,
            onSectionRemarkChange
        } = this.props
        // const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order' || type === 'notice'
        const isLocked = false
        const isWP = type === 'working-progress'
        const isWPR = type === 'work-progress-report'

        if (isWP || isWPR)
            return _.map(remarkList, (remark, remarkIdx) => {
                return (
                    <tr key={`${sectionOriginalIdx || sectionIdx}-${remarkIdx}`} className="remark-row">
                        <td colSpan={4} className="remark-field">
                            <div className="table-item">{remark}</div>
                        </td>
                    </tr>
                )
            })
        else
            return _.map(remarkList, (remark, remarkIdx) => {
                return (
                    <tr key={`${sectionOriginalIdx || sectionIdx}-${remarkIdx}`} className="remark-row">
                        <td className="remark-insert-field">
                            {
                                !isLocked && (
                                    <div className="insert-item-btn" onClick={onSectionRemarkInsert.bind(this, sectionIdx, remarkIdx)}>
                                        <Icon type="rollback" />
                                    </div>
                                )
                            }
                        </td>
                        <td colSpan={10} className="remark-field">
                            {
                                isLocked ? <div className="table-item">{remark}</div> :
                                (
                                    <Input 
                                        placeholder={'Input remark content'}
                                        value={remark} 
                                        onChange={onSectionRemarkChange.bind(this, sectionIdx, remarkIdx)}
                                    />
                                )
                            }
                        </td>
                        <td className="remark-rm-field">
                            {
                                !isLocked && (
                                    <div className="rm-item-btn" onClick={onSectionRemarkRemove.bind(this, sectionIdx, remarkIdx)}>
                                        <Icon type="close" />
                                    </div>
                                )
                            }
                        </td>
                    </tr>
                )
            })
    }

    renderSectionRow() {
        const {
            status,
            type,
            isDocumentSent,
            sections,
            onItemAdd,
            onSectionChange,
            onSectionRemove,
            onSectionToggle,
            onSectionRemarkAdd,
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'
        const isNotice = type === 'notice'
        const isWP = type === 'working-progress'
        const isWPR = type === 'work-progress-report'

        if (isWP || isWPR)
            return _.map(sections, (section, sectionIdx) => (
                <div className="section" key={sectionIdx}>
                    <div className="section-header">
                        <div className="section-idx">{sectionIdx + 1}.0</div>
                        <div className="section-name">{section.name}</div>
                        <div className="right-control">
                            <div className={`toggle-btn${section.toggled ? ' toggled' : ''}`} onClick={onSectionToggle.bind(this, sectionIdx)}>
                                <Icon type="up" />
                            </div>
                        </div>
                    </div>
                    <table className={`item-table${section.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th className="item-name-field">Item</th>
                                <th width={40}>Image</th>
                                <th width={80}>Progress</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderItemRow(sectionIdx, section.original_idx, section.items)}
                            {this.renderRemarkRow(sectionIdx, section.original_idx, section.remarks)}
                        </tbody>
                    </table>
                </div>
            ))
        else
            return _.map(sections, (section, sectionIdx) => (
                <div className="section" key={(section.original_idx, sectionIdx)}>
                    <div className="section-header">
                        <div className="section-idx">{(section.original_idx, sectionIdx) + 1}.0</div>
                        <div className="section-name">
                            {
                                isLocked || isNotice || isWP ? section.name : 
                                <Input 
                                    placeholder={'Input section name'}
                                    value={section.name} 
                                    onChange={onSectionChange.bind(this, sectionIdx, 'name')} 
                                    disabled={isDocumentSent}
                                />
                            }
                        </div>
                        <div className="right-control">
                            <div className={`toggle-btn${section.toggled ? ' toggled' : ''}`} onClick={onSectionToggle.bind(this, sectionIdx)}>
                                <Icon type="up" />
                            </div>
                            {
                                !isLocked && (
                                    <div className="rm-section-btn" onClick={onSectionRemove.bind(this, sectionIdx)}>
                                        <Icon type="close" />
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <table className={`item-table${section.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th width={40}></th>
                                <th className="item-name-field">Item</th>
                                <th width={60}>Qty</th>
                                <th width={60} colSpan={2}>Basic Charge</th>
                                <th width={60} colSpan={2}>Unit Rate</th>
                                <th width={100}>Total</th>
                                <th width={40}>Image</th>
                                <th width={40}>Optional</th>
                                <th width={40}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderItemRow(sectionIdx, section.original_idx, section.items)}
                            { 
                                !isLocked && !isNotice && (   
                                    <tr className="add-item">
                                        <td colSpan={12}>
                                            <Button onClick={onItemAdd.bind(this, sectionIdx)}>
                                                Add Item
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            }
                            {this.renderRemarkRow(sectionIdx, section.original_idx, section.remarks)}
                            {
                                !isNotice && (
                                    <tr className="add-remark">
                                        <td colSpan={12}>
                                            <Button onClick={onSectionRemarkAdd.bind(this, sectionIdx)}>
                                                Add Remark
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            }
                            <tr className="sub-total">
                                <td colSpan={10}>
                                    Sub-total
                                </td>
                                <td colSpan={2}>
                                    {numeral(getSectionTotal(section.items)).format('$ 0,0.[0]')}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ))
    }

    rendeNoticeSectionItemRow(itemList) {
        const {
            status,
            type,
            isDocumentSent,
            itemNameSuggestionList,
            unitSuggestionList,
            itemSmartSuggestionList,
            onNoticeSuggestionItemClick,
            onNoticeSectionItemFocus,
            onNoticeSectionItemInsert,
            onNoticeSectionItemRemove,
            onNoticeSectionItemChange,
            onNoticeSectionItemValueChange,
            onNoticeSectionItemImageChange
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'
        const isWP = type === 'working-progress'
        const isWPR = type === 'work-progress-report'
        const itemNameOptions = _.map(itemNameSuggestionList, (itemName, idx) => (
            <Option key={itemName}>
                {itemName}
                <div className="item-name-delete-btn" onClick={(e) => this.handleItemNameRemove(e, itemName)}>
                    <Icon type="close" />
                </div>
            </Option>
        ))

        if (isWP || isWPR)
            return _.map(itemList, (item, itemIdx) => {
                const { name, imageUrl, progress } = item
                return (
                    <tr key={`notice-section-${itemIdx}`}>
                        <td>{itemIdx + 1}</td>
                        <td className="item-name-field">
                            <div className="table-item">{name}</div>
                        </td>
                        <td>
                            <UploadWithPopupPreview
                                itemImageUrl={imageUrl}
                                itemImageChange={(url) => onNoticeSectionItemImageChange(itemIdx, url)}
                                isLocked={isWPR}
                            />
                        </td>
                        <td>
                            {isWPR ? progress : <Input value={progress} onChange={onNoticeSectionItemChange.bind(this, itemIdx, 'progress')}/>}
                        </td>
                    </tr>
                )
            })
        else
            return _.map(itemList, (item, itemIdx) => {
                const { name, quantity, basic_charge_quantity, basic_charge, unit_rate, unit, imageUrl, optional } = item
                return (
                    <tr key={`notice-section-${itemIdx}`}>
                        <td className="insert-item-field">
                            {
                                !isLocked && (
                                    <div className="insert-item-btn" onClick={onNoticeSectionItemInsert.bind(this, itemIdx)}>
                                        <Icon type="rollback" />
                                    </div>
                                )
                            }
                        </td>
                        <td className="item-idx-field">{itemIdx + 1}</td>
                        <td className="item-name-field">
                            { 
                                isLocked ? <div className="table-item">{name}</div> :
                                <AutoComplete
                                    value={name}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'name')}
                                    dataSource={itemNameOptions}
                                    optionLabelProp='value'
                                    style={{width: '100%'}}
                                    filterOption={(inputValue, option) => option.props.children[0].toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                    dropdownMatchSelectWidth={false}
                                />
                            }
                        </td>
                        <td width={60}>
                            { 
                                isLocked ? <div className="table-item">{quantity}</div> :
                                <InputNumber 
                                    prefixCls="ant-input-number" 
                                    value={quantity}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'quantity')}
                                />
                            }
                        </td> 
                        <td width={80}>
                            { 
                                isLocked ? <div className="table-item">{basic_charge_quantity && `First ${basic_charge_quantity}`}</div> :
                                <SmartInputNumber 
                                    prefixCls="ant-input-number"
                                    min={1} 
                                    formatter={value => value ? `First ${value}` : ''}
                                    parser={value => value.replace(/[^0-9.]/g, '')}
                                    value={basic_charge_quantity}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'basic_charge_quantity')}
                                    onFocusFetcher={onNoticeSectionItemFocus.bind(this, itemIdx)}
                                    onRowClick={(selectedItem) => onNoticeSuggestionItemClick(itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={80}>
                            { 
                                isLocked ? <div className="table-item">{basic_charge && `$ ${numeral(basic_charge).format('0,0.[0]')}`}</div> :
                                <SmartInputNumber 
                                    prefixCls="ant-input-number" 
                                    formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    value={basic_charge}
                                    min={0}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'basic_charge')}
                                    onFocusFetcher={onNoticeSectionItemFocus.bind(this, itemIdx)}
                                    onRowClick={(selectedItem) => onNoticeSuggestionItemClick(itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={70}>
                            { 
                                isLocked ? <div className="table-item">{unit_rate && `$ ${numeral(unit_rate).format('0,0.[0]')}`}</div> :
                                <SmartInputNumber 
                                    prefixCls="ant-input-number" 
                                    formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    value={unit_rate}
                                    min={0}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'unit_rate')}
                                    onFocusFetcher={onNoticeSectionItemFocus.bind(this, itemIdx)}
                                    onRowClick={(selectedItem) => onNoticeSuggestionItemClick(itemIdx, selectedItem)}
                                    itemName={name}
                                    itemSmartSuggestionList={itemSmartSuggestionList}
                                />
                            }
                        </td>
                        <td width={50}>
                            { 
                                isLocked ? <div className="table-item">{unit}</div> :
                                <AutoComplete
                                    value={unit}
                                    onChange={onNoticeSectionItemValueChange.bind(this, itemIdx, 'unit')}
                                    dataSource={unitSuggestionList}
                                    style={{width: '100%'}}
                                    filterOption={(inputValue, option) => option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                    dropdownMatchSelectWidth={false}
                                />
                            }
                        </td>
                        <td><div className="table-item">{numeral(getItemTotal(item)).format('$ 0,0.[0]')}</div></td>
                        <td>
                            <UploadWithPopupPreview
                                isLocked={isLocked}
                                itemImageUrl={imageUrl}
                                itemImageChange={(url) => onNoticeSectionItemImageChange(itemIdx, url)}
                            />
                        </td>
                        <td>
                            <Checkbox 
                                checked={optional} 
                                disabled={isLocked}
                                onChange={onNoticeSectionItemChange.bind(this, itemIdx, 'optional')}
                            />
                        </td>
                        <td>
                            {
                                !isLocked && (
                                    <div className="rm-item-btn" onClick={onNoticeSectionItemRemove.bind(this, itemIdx)}>
                                        <Icon type="close" />
                                    </div>
                                )
                            }
                        </td>
                    </tr>
                )
            })
    }

    renderNoticeSectionRow() {
        const {
            status,
            type,
            isDocumentSent,
            noticeSections,
            onNoticeSectionItemAdd,
            onNoticeSectionToggle
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent
        const isVariationOrder = type === 'variation-order'
        const isWP = type === 'working-progress'
        const isWPR = type === 'work-progress-report'

        if ((isWP || isWPR) && noticeSections.items.length !== 0)
            return (
                <div className="section">
                    <div className="section-header">
                        <div className="section-name">Others</div>
                        <div className="right-control">
                            <div className={`toggle-btn${noticeSections.toggled ? ' toggled' : ''}`} onClick={onNoticeSectionToggle.bind(this)}>
                                <Icon type="up" />
                            </div>
                        </div>
                    </div>
                    <table className={`item-table${noticeSections.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th>Item</th>
                                <th width={40}>Image</th>
                                <th width={80}>Progress</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.rendeNoticeSectionItemRow(noticeSections.items)}
                        </tbody>
                    </table>
                </div>
            )
        else if (!isWP && !isWPR && (!isLocked || noticeSections.items.length !== 0))
            return (
                <div className="section">
                    <div className="section-header">
                        <div className="section-name">Others</div>
                        <div className="right-control">
                            <div className={`toggle-btn${noticeSections.toggled ? ' toggled' : ''}`} onClick={onNoticeSectionToggle.bind(this)}>
                                <Icon type="up" />
                            </div>
                        </div>
                    </div>
                    <table className={`item-table${noticeSections.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th width={40}></th>
                                <th>Item</th>
                                <th width={60}>Qty</th>
                                <th width={60} colSpan={2}>Basic Charge</th>
                                <th width={60} colSpan={2}>Unit Rate</th>
                                <th width={100}>Total</th>
                                <th width={40}>Image</th>
                                <th width={40}>Optional</th>
                                <th width={40}></th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.rendeNoticeSectionItemRow(noticeSections.items) }
                            { 
                                !isLocked && !isVariationOrder && (   
                                    <tr className="add-item">
                                        <td colSpan={12}>
                                            <Button onClick={onNoticeSectionItemAdd.bind(this)}>
                                                Add Item
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            }
                            <tr className="sub-total">
                                <td colSpan={10}>
                                    Sub-total
                                </td>
                                <td colSpan={2}>
                                    { numeral(getSectionTotal(noticeSections.items)).format('$ 0,0.[0]') }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
    }

    renderDiscountSection() {
        const { onDiscountAdd, onDiscountRemove, onDiscountChange, onDiscountValueChange, type, status, isDocumentSent, discounts } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'

        let discountGp = _.map(discounts, (discount, discountIdx) => (
            <Row gutter={8} className="discount-row" key={`discount-${discountIdx}`}>
                <Col span={20}>
                    {
                        isLocked ? <div className="discount-name-text">{discount.name}</div> : 
                        <Input 
                            placeholder="Input discount name"
                            value={discount.name} 
                            onChange={onDiscountChange.bind(this, discountIdx, 'name')}
                        />
                    }
                </Col>
                <Col span={isLocked ? 4 : 3}>
                    {
                        isLocked ? <div className="discount-amount-text">{numeral(discount.amount).format('$ 0,0.[0]')}</div> : 
                        <InputNumber 
                            className="discount-amount"
                            prefixCls="ant-input-number" 
                            formatter={value => value ? `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            value={discount.amount} 
                            onChange={onDiscountValueChange.bind(this, discountIdx, 'amount')}
                        />
                    }
                </Col>
                {
                    !isLocked && (
                        <Col span={1}>
                            <div className="rm-discount-btn" onClick={onDiscountRemove.bind(this, discountIdx)}>
                                <Icon type="close" />
                            </div>
                        </Col>
                    )
                }
            </Row>
        ))

        if (!isLocked)
            discountGp.push(<Button key="add-discount-btn" className="add-discount-btn" onClick={onDiscountAdd.bind(this)}>Add Discount</Button>)

        if (!isLocked || discounts.length !== 0)
            return (
                <div className="discount-gp">
                    { discountGp }
                </div>
            )
    }

    render() {
        const { status, type, onSectionAdd, isDocumentSent, sections, noticeSections, discounts } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'
        const isNoticeType = type === 'notice' || type === 'variation-order'
        const isWP = type === 'working-progress' || type === 'work-progress-report'
        const grandTotal = getGrandTotal(type, sections, noticeSections, discounts)

        return (
            <div className="DocumentContentTable">
                { this.renderSectionRow() }
                { (isNoticeType || isWP) && this.renderNoticeSectionRow() }
                { !isWP && !isNoticeType && !isLocked && (<Button type="primary" size="large" onClick={onSectionAdd.bind(this)}>Add Section</Button>) }
                { !isWP && this.renderDiscountSection() }
                { !isWP && (<div className="grand-total">Grand Total: {numeral(grandTotal).format('$ 0,0.[0]')}</div>) }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/DocumentContentTable/DocumentContentTable.js